import { BarbarianFuryParsedGameData } from './../server/data/BarbarianFuryParsedGameData';
import { BarbarianFuryParsedInitData } from './../server/data/BarbarianFuryParsedInitData';
import { Helper } from '@nolimitcity/slot-game/bin/core/utils/Helper';
import { GameResources } from '@nolimitcity/slot-game/bin/core/resource/GameResources';
import { BarbarianFuryGameConfig } from './../BarbarianFuryGameConfig';
import { StageManager } from '@nolimitcity/slot-game/bin/core/stage/StageManager';
import { ScalableLayer } from '@nolimitcity/slot-game/bin/core/stage/ScalableLayer';
import { BaseView } from '@nolimitcity/slot-game/bin/core/base/BaseView';
import { IBetLineWinData } from '@nolimitcity/slot-game/bin/core/server/data/IServerData';
import {BarbarianFuryGameAssets} from "../BarbarianFuryGameAssets";

export class BarbarianBetlineView extends BaseView {

    private _layer: ScalableLayer;
    private _betlineContainer: PIXI.Sprite[];
    private _reverseBetlineArray: number[] = [4, 5, 11, 12, 13, 14, 15, 16, 22, 23, 24];
    public _initData: BarbarianFuryParsedInitData;
    private _betline: PIXI.Sprite;
    public _parsedGameData: BarbarianFuryParsedGameData;
    public _showBetlineAmount: boolean = false;
    private _betWinAmount: PIXI.BitmapText;
    private _winAmountShadow: PIXI.Sprite;

    constructor() {
        super();
    }

    /**
     * override this function to draw betlines
     */
    protected initAnimations(): void {
        super.initAnimations && super.initAnimations();
        this._winAmountShadow = this._winAmountShadow = new PIXI.Sprite(GameResources.getTextures(BarbarianFuryGameAssets.WIN_AMOUNT_SHADOW)[0]);
        this._winAmountShadow.scale.set(2.6, 2.3);
        this._winAmountShadow.anchor.set(0.5);
        this._layer = StageManager.getLayer(BarbarianFuryGameConfig.instance.LAYERS.BET_LINES.name);
        this._betlineContainer = [];
        this.drawBetlines();
        this._betWinAmount = new PIXI.BitmapText("0", {
            fontName: "NumbersWinCountUp",
            fontSize: 10
        });

    }
    private showBetWinAmount(betlineIndex: number): void {
        if (!this._showBetlineAmount) {
            return;
        }
        let betLine = this._initData.betLines[betlineIndex]; // eg: [1,2,3,2,1] betline starting index
        let data: IBetLineWinData[] = this._parsedGameData.betWins as IBetLineWinData[];
        this._betWinAmount.text = "";
        for (let index = 0; index < data.length; index++) {
            if (data[index].betLineIndex === betlineIndex) {
                this._betWinAmount.text = data[index].multipliedAmount.toFixed(2).toString(); // #150 fix
                this._betWinAmount.pivot.set(this._betWinAmount.width / 2, this._betWinAmount.height / 2)
                this._betWinAmount.position.set(Helper.getSymbolPositions(2, 0)[0], Helper.getSymbolPositions(0, betLine[2])[1]);
                this._winAmountShadow.position.set(Helper.getSymbolPositions(2, 0)[0], Helper.getSymbolPositions(0, betLine[2])[1]);
                this._winAmountShadow.width = this._betWinAmount.width * 2;
                this._winAmountShadow.height = this._betWinAmount.height * 2;
                this._layer.addChild(this._winAmountShadow);
                this._layer.addChild(this._betWinAmount);
            }
        }

    }



    /**
     * funtion to show betline from index
     * @param betlineIndex 
     */
    public showBetline(betlineIndex: number) {

        betlineIndex -= 1;
        if (this._reverseBetlineArray.indexOf(betlineIndex) !== -1) {
            this._betlineContainer[betlineIndex].scale.y = -1;
        }
        this.positionBetlines(betlineIndex);
        this.showBetWinAmount(betlineIndex);
        this._layer.addChild(this._betlineContainer[betlineIndex]);
    }

    /**
     * function to position some nerdy betlines
     * @param betlineIndex 
     */
    private positionBetlines(betlineIndex: number) {
        let betLine = this._initData.betLines[betlineIndex]; // eg: [1,2,3,2,1] betline starting index
        switch (betlineIndex) {
            case 11:
            case 12:
            case 13:
                this._betlineContainer[betlineIndex].position.set(0, Helper.getSymbolPositions(0, betLine[0])[1] + 28);
                break;
            case 8:
            case 9:
            case 10:
                this._betlineContainer[betlineIndex].position.set(0, Helper.getSymbolPositions(0, betLine[0])[1] - 28);
                break;
            default:
                this._betlineContainer[betlineIndex].position.set(0, (Helper.getSymbolPositions(0, betLine[0])[1]));
                break;
        }
    }

    /**
     * function to draw betline based on index
     */
    private drawBetlines(): void {
        for (let index = 0; index < 25; index++) {
            switch (index) {
                case 0:
                case 1:
                case 2:
                case 3:
                    this._betline = new PIXI.Sprite(GameResources.getTextures("Betline0")[0]);
                    this._betline.position.set(0, Helper.getSymbolPositions(0, index)[0]);
                    this._betline.anchor.y = 0.5
                    this._betlineContainer.push(this._betline);
                    this._betlineContainer[index].blendMode = PIXI.BLEND_MODES.ADD;
                    break;
                case 4:
                case 5:
                case 6:
                case 7:
                    this._betline = new PIXI.Sprite(GameResources.getTextures("Betline1")[0]);
                    this._betlineContainer.push(this._betline);
                    this._betlineContainer[index].blendMode = PIXI.BLEND_MODES.ADD;
                    break;
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                    this._betline = new PIXI.Sprite(GameResources.getTextures("Betline2")[0]);
                    this._betlineContainer.push(this._betline);
                    this._betlineContainer[index].blendMode = PIXI.BLEND_MODES.ADD;
                    break;
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                    this._betline = new PIXI.Sprite(GameResources.getTextures("Betline3")[0]);
                    this._betline.anchor.y = 0.2
                    this._betlineContainer.push(this._betline);
                    this._betlineContainer[index].blendMode = PIXI.BLEND_MODES.ADD;
                    break;
                case 20:
                case 21:
                case 22:
                case 23:
                case 24:
                    this._betline = new PIXI.Sprite(GameResources.getTextures("Betline4")[0]);
                    this._betline.anchor.y = 0.2
                    this._betlineContainer.push(this._betline);
                    this._betlineContainer[index].blendMode = PIXI.BLEND_MODES.ADD;
                    break;
                default:
                    break;
            }
        }
    }

    /**
     * function to hide all betlines
     */
    public hideAllBetlines() {
        this._layer.removeChildren();
        this._betWinAmount.text = ""
    }
}